import { render } from "./DashboardComms.vue?vue&type=template&id=2f5091c4&scoped=true&ts=true"
import script from "./DashboardComms.vue?vue&type=script&lang=ts"
export * from "./DashboardComms.vue?vue&type=script&lang=ts"

import "./DashboardComms.vue?vue&type=style&index=0&id=2f5091c4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5091c4"]])

export default __exports__